// extracted by mini-css-extract-plugin
export default {"leftControls":"fa_fb","leftControls__item":"fa_fc","leftControls__item_hidden":"fa_fe","leftControls__item_betOnAll":"fa_ff"};